import { render, staticRenderFns } from "./AddEditMaterial.vue?vue&type=template&id=7a40683c&scoped=true"
import script from "./AddEditMaterial.vue?vue&type=script&lang=js"
export * from "./AddEditMaterial.vue?vue&type=script&lang=js"
import style0 from "./AddEditMaterial.vue?vue&type=style&index=0&id=7a40683c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a40683c",
  null
  
)

export default component.exports